import { SliceCreator } from '../TrainingState';
import {
  SaveAnswersMutation,
  SaveAnswersMutationVariables,
  SaveAnswersDocument
} from '~/data';
import { client } from '~/data/client';

export interface QuestionAnswersSlice {
  saveQuestionAnswers: (
    questionFieldId: string,
    chapterSequenceId: string
  ) => void;
}

/**
 * Save question answers on the back-end
 * @param variables The GraphQL query variables
 * @returns The values that have been updated
 */
export async function saveQuestionAnswers(variables: {
  learnerTrainingUuid: string;
  chapterSequenceId: string;
  questionFieldId: string;
}) {
  const result = await client.mutate<
    SaveAnswersMutation,
    SaveAnswersMutationVariables
  >({
    mutation: SaveAnswersDocument,
    variables
  });

  if (result.errors?.length || result.data?.saveAnswers?.errors.length) {
    throw new Error('Error saving settings...');
  }

  return variables;
}

export const createSaveQuestionAnswersRequest: SliceCreator<
  QuestionAnswersSlice
> = (set, get) => {
  /**
   * @param newValues contain data about question
   */
  async function storeQuestionAnswers(
    newValues: Partial<SaveAnswersMutationVariables>
  ) {
    const { learnerTrainingId, chapterSequenceId } = get();

    return await saveQuestionAnswers({
      learnerTrainingUuid: learnerTrainingId,
      chapterSequenceId: chapterSequenceId,
      questionFieldId: '',
      ...newValues
    });
  }

  return {
    saveQuestionAnswers: (
      questionFieldId: string,
      chapterSequenceId: string
    ) => {
      const belongsToTraining = get().items.some(
        item =>
          item.kind === 'sequence' &&
          item.chapterSequenceId === chapterSequenceId
      );
      if (!belongsToTraining) return;

      storeQuestionAnswers({
        questionFieldId,
        chapterSequenceId
      }).then();
    }
  };
};
